export default __webpack_public_path__ + "static/media/Gwent-Mod1-InCourseWorkbook.9fc51fb4.pdf";